export default __webpack_public_path__ + "static/media/telegram.e39097b7.svg";